import { render } from "./SkillsSubPanel.vue?vue&type=template&id=c09de366"
import script from "./SkillsSubPanel.vue?vue&type=script&lang=js"
export * from "./SkillsSubPanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__